import { configureStore } from '@reduxjs/toolkit';
import userReducer from './features/userSlice';
import stationReducer from './features/stationSlice';
import settingReducer from './features/settingSlice'

const store = configureStore({
  reducer: {
    setting: settingReducer,
    user: userReducer,
    station: stationReducer,
  },

});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
